module.exports = __webpack_public_path__ + "753bd08e38a9edaae830ae69a72837af.svg";